import ShortDesc from './lib/ShortDesc';

export default ShortDesc;
